import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hiv/icons/arrow-right.png'


const _withScopeId = n => (_pushScopeId("data-v-a0fef0ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "btn btn-default btn-home-default" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.link,
    target: "_blank",
    class: "btn-link"
  }, [
    _createElementVNode("button", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      _hoisted_3
    ])
  ], 8, _hoisted_1))
}